import { MfaMethod } from '@shared/services';

export const METHOD_LABEL: Record<MfaMethod, string> = {
  [MfaMethod.PASSKEY]: 'Passkey',
  [MfaMethod.TOTP]: 'Authenticator app',
  [MfaMethod.EMAIL]: 'Email',
};

export const ENROLL_DESCRIPTION: Record<MfaMethod, string> = {
  [MfaMethod.PASSKEY]: 'Register this device with biometrics or a security key.',
  [MfaMethod.TOTP]: 'Scan a QR code with an authenticator app such as Google Authenticator.',
  [MfaMethod.EMAIL]: 'Receive one-time codes by email.',
};

export const VERIFY_DESCRIPTION: Record<MfaMethod, string> = {
  [MfaMethod.PASSKEY]: 'Sign in with your device biometrics or a security key.',
  [MfaMethod.TOTP]: 'Enter a code from your authenticator app or a backup code.',
  [MfaMethod.EMAIL]: 'Get a one-time code sent to your email.',
};
